import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { VesselServiceConfigure, VesselServiceConfigureParams } from './model';
import { VesselServiceConfigureView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export const VesselServiceConfigureRoute = (
    model : (params : VesselServiceConfigureParams) => VesselServiceConfigure,
    appWrapper : AppWrapper,
    request : Location
) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <VesselServiceConfigureView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : VesselServiceConfigureParams {
    return {
        id: +(request.params['id'] || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceconfigure/route.tsx